<div class="modal-overlay" *ngIf="show">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container" [ngClass]="variant">
          <fa-icon [icon]="icon || faExclamationTriangle"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ title | translate }}</h3>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <p class="confirm-message">{{ message | translate }}</p>
      <ng-content></ng-content>
    </div>

    <div class="modal-footer">
      <app-button 
        [text]="'BUTTON.CANCEL' | translate" 
        variant="secondary" 
        (clicked)="onClose()">
      </app-button>
      <app-button 
        [text]="confirmLabel | translate" 
        [variant]="btnVariant" 
        [icon]="icon"
        [loading]="loading"
        (clicked)="onConfirm()">
      </app-button>
    </div>
  </div>
</div>
